export const categories = [
  {
    slug: "xiaohua-pingxuan",
    name: "校花评选",
    description: "各大高校校花评选规则、评选活动详情与最新动态",
    icon: "ri-award-line",
    color: "secondary",
    imageSeq: "category-pingxuan",
  },
  {
    slug: "xiaohua-gushi",
    name: "校花故事",
    description: "校花背后的青春故事、成长经历与校园回忆",
    icon: "ri-heart-line",
    color: "accent",
    imageSeq: "category-gushi",
  },
  {
    slug: "meili-xiaoyuan",
    name: "美丽校园",
    description: "中国最美大学校园风光与人文景观探索",
    icon: "ri-landscape-line",
    color: "primary",
    imageSeq: "category-xiaoyuan",
  },
  {
    slug: "qingchun-jiyi",
    name: "青春记忆",
    description: "大学生活中的美好瞬间、青春感悟与成长故事",
    icon: "ri-sun-line",
    color: "secondary",
    imageSeq: "category-qingchun",
  },
];

export const articles = [
  {
    id: 1,
    title: "清华大学2025年度校花评选圆满落幕：才貌双全的理工女孩夺魁",
    slug: "tsinghua-2025-campus-belle",
    excerpt: "在刚刚结束的清华大学2025年度校花评选中，来自计算机系的大三学生林雨晴凭借出众的才华与独特气质，从众多参赛选手中脱颖而出，荣获本届校花桂冠。评选过程历时一个月，涵盖才艺展示、学术答辩、公益实践等多个环节。",
    content: `在刚刚结束的清华大学2025年度校花评选中，来自计算机系的大三学生林雨晴凭借出众的才华与独特气质，从众多参赛选手中脱颖而出，荣获本届校花桂冠。

## 评选过程

本次评选活动历时一个月，由清华大学学生会主办，吸引了来自全校各个院系的近百名优秀女生报名参加。评选过程涵盖才艺展示、学术答辩、公益实践等多个环节，全方位考察参赛选手的综合素质。

### 初选阶段
初选阶段以线上投票和材料审核相结合的方式进行。每位参赛选手需要提交个人简历、学业成绩单、才艺展示视频以及社会实践证明材料。评审团由校学生会代表、教师代表和往届校花组成，对选手进行综合评分。

### 复赛环节
复赛环节包括现场才艺展示和即兴演讲两部分。选手们展示了舞蹈、声乐、器乐、书法等多样才艺，同时在即兴演讲环节围绕"新时代大学生的责任与担当"主题发表见解。

### 决赛之夜
决赛之夜在清华大礼堂隆重举行，十强选手经过礼服展示、智慧问答和公益项目路演三轮比拼，最终由现场观众投票和评审团打分共同决定名次。

## 冠军风采

林雨晴同学不仅学业成绩优异（GPA 3.92），还曾获得国际大学生程序设计竞赛金牌。在公益方面，她发起"代码支教"项目，利用周末时间为偏远地区中小学生教授编程知识，该项目已覆盖全国12个省份的50余所学校。

"美不仅仅是外表，更是一种由内而外的气质。"林雨晴在获奖感言中说道，"我希望通过这个平台，让更多人关注女性在科技领域的成长与发展。"

## 往届回顾

清华大学校花评选活动始于2010年，至今已成功举办15届。历届校花中走出了科研工作者、企业家、公益人士等各行各业的优秀女性代表。`,
    category: "xiaohua-pingxuan",
    author: "校园记者 张晓",
    publishDate: "2025-12-15",
    readTime: "8分钟",
    imageSeq: "article-tsinghua-1",
    tags: ["清华大学", "校花评选", "林雨晴", "理工女孩"],
  },
  {
    id: 2,
    title: "北大校花杨雨薇：从校园女神到公益大使的蜕变之路",
    slug: "pku-yang-yuwei-transformation",
    excerpt: '北京大学2024届校花杨雨薇毕业后选择了一条不同寻常的道路——投身公益事业。她创立的「阳光书屋」项目已在全国建立200余个乡村图书馆，用知识和爱心点亮了无数孩子的未来。',
    content: `北京大学2024届校花杨雨薇毕业后选择了一条不同寻常的道路——投身公益事业。她创立的「阳光书屋」项目已在全国建立200余个乡村图书馆，用知识和爱心点亮了无数孩子的未来。

## 校园时代

杨雨薇在北京大学就读期间，主修社会学，辅修艺术史。她不仅学业优秀，还活跃于校园各类文化活动。作为北大舞蹈团的骨干成员，她多次代表学校参加全国大学生艺术展演。

"在北大读书的四年是我人生中最美好的时光。"杨雨薇回忆道，"未名湖畔的晨读、图书馆里的挑灯夜战、五四操场的奔跑，每一刻都弥足珍贵。"

## 校花评选经历

2024年，杨雨薇参加了北京大学校花评选。与其他选手不同的是，她的参选宣言并非关于美貌，而是关于"知识女性的社会责任"。这一独特视角打动了评委和观众，最终以高票当选。

"校花评选对我来说不仅仅是一个头衔，更是一份责任。"杨雨薇说，"我希望用这份关注度去做一些有意义的事情。"

## 公益之路

毕业后，杨雨薇放弃了多家知名企业的高薪邀约，选择全身心投入公益事业。她创立的"阳光书屋"项目致力于为偏远地区儿童建立图书室，提供优质的阅读资源和教育支持。

截至2025年底，"阳光书屋"已在全国23个省份建立200余个乡村图书馆，累计捐赠图书超过50万册，惠及超过10万名乡村儿童。

## 社会影响

杨雨薇的故事被多家主流媒体报道，她本人也获得了"中国青年公益之星"、"全国三八红旗手"等荣誉称号。2025年，她还受邀在TEDx演讲中分享自己的公益理念，引起了广泛的社会关注。`,
    category: "xiaohua-gushi",
    author: "特约记者 李文",
    publishDate: "2025-11-28",
    readTime: "10分钟",
    imageSeq: "article-pku-1",
    tags: ["北京大学", "杨雨薇", "公益", "校花故事"],
  },
  {
    id: 3,
    title: "武汉大学樱花季：最美校园里的青春映像",
    slug: "whu-sakura-season-beauty",
    excerpt: "每年三月，武汉大学的樱花如约绽放，吸引无数游客前来观赏。在这片粉色的花海中，武大学子们用镜头记录下了最美的青春瞬间。从樱花大道到老斋舍，从珞珈山到东湖畔，每一处都是青春与美景的完美交融。",
    content: `每年三月，武汉大学的樱花如约绽放，吸引无数游客前来观赏。在这片粉色的花海中，武大学子们用镜头记录下了最美的青春瞬间。

## 樱花与武大

武汉大学的樱花种植历史可追溯至1939年。如今，校园内共有樱花树1000余株，分布在樱花大道、老斋舍、行政楼周边等多个区域。每年樱花盛开时节，整个校园如同置身于粉色的童话世界。

## 最佳观赏地点

### 樱花大道
樱花大道是武大最著名的赏樱地点，长约600米的道路两侧樱花树成行排列。盛开时节，花瓣随风飘落，形成著名的"樱花雨"景观。

### 老斋舍
老斋舍前的樱花树龄较长，枝干虬劲，花开时与古典建筑相映成趣，是摄影爱好者的最爱。

### 珞珈山
登临珞珈山俯瞰樱花大道，可以欣赏到樱花与校园建筑交相辉映的壮丽景色。

## 学子风采

每年樱花季，武大学子们自发组织各类文化活动——汉服游园、诗歌朗诵、摄影比赛、樱花市集等。这些活动不仅丰富了校园文化生活，也成为了武大独特的青春记忆。

"在樱花树下读书、与朋友漫步，是我大学生活中最美好的记忆。"一位武大文学院的学生说道。

## 游览贴士

樱花花期通常在3月中旬至4月初，持续约2-3周。游客可通过武汉大学官方微信公众号提前预约进校。建议选择工作日前来，避开周末人流高峰。`,
    category: "meili-xiaoyuan",
    author: "旅行编辑 王芳",
    publishDate: "2025-03-20",
    readTime: "7分钟",
    imageSeq: "article-whu-1",
    tags: ["武汉大学", "樱花", "校园风光", "最美校园"],
  },
  {
    id: 4,
    title: "大学四年：那些年我们一起追过的校花",
    slug: "college-years-campus-belle-memories",
    excerpt: "每个大学都有那么几个让人过目不忘的女孩。她们可能是图书馆里安静读书的学姐，也可能是操场上活力四射的学妹，亦或是舞台上光芒万丈的校园明星。这篇文章带你重温那些关于校花的青春记忆。",
    content: `每个大学都有那么几个让人过目不忘的女孩。她们可能是图书馆里安静读书的学姐，也可能是操场上活力四射的学妹，亦或是舞台上光芒万丈的校园明星。

## 记忆中的她

大学四年，总有一些面孔深深印刻在我们的记忆中。她们不一定参加过正式的校花评选，但在同学们心中，她们就是当之无愧的校花。

### 图书馆女孩
她总是坐在图书馆三楼靠窗的位置，阳光透过玻璃洒在她的侧脸上。手中的书页轻轻翻动，偶尔抬起头望向窗外的梧桐树。没有人知道她的名字，但每个常去图书馆的人都认识她。

### 操场上的身影
每天傍晚，她都会出现在操场上。扎着高高的马尾，穿着简单的运动装，一圈又一圈地奔跑。汗水在夕阳下闪闪发光，那种专注和坚持让人移不开目光。

## 校花文化的变迁

从上世纪90年代的口口相传，到2000年代的校园BBS投票，再到如今的新媒体平台评选，校花文化经历了巨大的变迁。

早期：校花更多是同学间的私下评选，流传于宿舍夜谈和食堂闲聊中。

中期：随着校园BBS的兴起，开始出现正式的投票和排名。清华大学的水木清华BBS、北京大学的北大未名BBS都曾举办过轰动一时的校花评选。

现在：抖音、小红书等新媒体平台让校花评选更加公开和多元化。评选标准也从单一的颜值转向综合素质的考量。

## 青春的意义

校花文化之所以经久不衰，不仅仅是因为对美的追求，更深层次的原因在于它承载了我们的青春记忆。那些关于校花的故事，其实是我们自己青春故事的投影。

"现在回想起来，当年追过的校花叫什么名字已经不重要了。重要的是那段无忧无虑的青春时光，和那群一起疯一起闹的兄弟们。"一位毕业十年的校友感慨道。`,
    category: "qingchun-jiyi",
    author: "专栏作者 陈明",
    publishDate: "2025-09-10",
    readTime: "12分钟",
    imageSeq: "article-memories-1",
    tags: ["青春记忆", "大学时光", "校花文化", "校园生活"],
  },
  {
    id: 5,
    title: "2025全国高校校花评选规则全面解读",
    slug: "2025-nationwide-campus-belle-rules",
    excerpt: "随着校花文化的发展，越来越多的高校建立了规范的校花评选制度。本文全面梳理了当前主流高校的校花评选规则，包括报名条件、评选流程、评分标准和注意事项。",
    content: `随着校花文化的发展，越来越多的高校建立了规范的校花评选制度。本文全面梳理了当前主流高校的校花评选规则。

## 评选宗旨

现代高校校花评选已不再是单纯的外貌比拼，而是旨在选拔德才兼备、全面发展的优秀女生代表，展现当代女大学生的精神风貌。

## 报名条件

不同高校的报名条件略有差异，但通常包括：

- 在校全日制本科或研究生
- 无违纪记录
- 学业成绩达到一定标准
- 具备至少一项才艺特长
- 热心公益和校园活动

## 评选流程

### 第一阶段：报名与初选（第1-2周）
选手提交报名材料，包括个人简介、照片、才艺视频等。评审团进行初步筛选，确定入围名单。

### 第二阶段：复赛（第3-4周）
入围选手参加现场面试和才艺展示。部分高校还会设置知识问答、即兴演讲等环节。

### 第三阶段：决赛（第5-6周）
决赛通常包括以下几个环节：
- 形象展示（礼服/正装展示）
- 才艺表演
- 智慧问答
- 公益项目路演
- 现场投票

## 评分标准

大多数高校采用综合评分体系：

| 评分项目 | 占比 | 说明 |
|---------|------|------|
| 学业成绩 | 20% | GPA及学术成果 |
| 才艺特长 | 25% | 艺术、体育等特长展示 |
| 公益实践 | 20% | 志愿服务和社会实践 |
| 综合素质 | 20% | 面试表现、应变能力 |
| 人气投票 | 15% | 同学投票和网络投票 |

## 争议与思考

校花评选也面临着一些争议。有人认为这种评选物化女性，有人则将其视为展示女性多元价值的平台。无论如何，确保评选过程的公平、公正、公开，尊重每一位参赛者的尊严，是所有评选活动应当遵循的基本原则。`,
    category: "xiaohua-pingxuan",
    author: "政策研究员 刘洋",
    publishDate: "2025-08-05",
    readTime: "9分钟",
    imageSeq: "article-rules-1",
    tags: ["评选规则", "校花评选", "高校活动", "评分标准"],
  },
  {
    id: 6,
    title: "浙大校花陈思琪：用舞蹈诠释东方之美",
    slug: "zju-chen-siqi-dance-story",
    excerpt: "浙江大学2024届校花陈思琪是一名中国古典舞爱好者。她将传统的东方美学与现代舞蹈元素融合，创作出一系列令人惊艳的作品。她的故事告诉我们：真正的美丽源于对艺术的热爱与坚持。",
    content: `浙江大学2024届校花陈思琪是一名中国古典舞爱好者。她将传统的东方美学与现代舞蹈元素融合，创作出一系列令人惊艳的作品。

## 舞蹈之路

陈思琪从5岁开始学习中国古典舞，至今已有18年的舞蹈功底。在浙江大学就读期间，她担任校舞蹈团团长，带领团队在全国大学生艺术展演中获得金奖。

"舞蹈是我表达情感的方式，也是我与世界对话的语言。"陈思琪说。

## 校花评选

在浙江大学2024年校花评选中，陈思琪以一支原创古典舞《江南烟雨》征服了所有评委和观众。舞蹈融合了水墨画的意境和现代编舞的技巧，展现了江南女子的婉约与坚韧。

## 艺术成就

陈思琪不仅在校园内广受欢迎，她的舞蹈作品还在多个平台上走红。她在B站发布的舞蹈视频累计播放量超过500万，被网友誉为"最美中国舞者"。

2025年，她受邀参加央视《舞蹈世界》节目录制，表演的原创作品《青花瓷韵》获得了专业评委的高度评价。

## 未来规划

毕业后，陈思琪计划赴英国皇家舞蹈学院深造，将中国传统舞蹈带向世界舞台。"我希望让更多人看到中国舞蹈的美，理解东方美学的精髓。"`,
    category: "xiaohua-gushi",
    author: "文化记者 孙悦",
    publishDate: "2025-07-18",
    readTime: "7分钟",
    imageSeq: "article-zju-1",
    tags: ["浙江大学", "陈思琪", "古典舞", "校花故事"],
  },
  {
    id: 7,
    title: "厦门大学：海风中的最美校园",
    slug: "xmu-seaside-beautiful-campus",
    excerpt: '厦门大学以其独特的海滨位置和优美的校园环境被誉为「中国最美大学」之一。从芙蓉湖到情人谷，从白城沙滩到上弦场，每一处都散发着独特的南国风光。',
    content: `厦门大学以其独特的海滨位置和优美的校园环境被誉为"中国最美大学"之一。

## 校园概况

厦门大学由著名爱国华侨领袖陈嘉庚先生于1921年创办，是中国近代教育史上第一所由华侨创办的大学。校园依山傍海，建筑风格融合了中西元素，既有嘉庚建筑的独特韵味，又有现代建筑的时尚气息。

## 必游景点

### 芙蓉湖
芙蓉湖是厦大校园内最著名的景点之一。湖面波光粼粼，湖畔绿树成荫，常有黑天鹅在湖中悠然游弋。清晨时分，湖面上笼罩着一层薄雾，宛如仙境。

### 情人谷
情人谷位于校园深处，是一条幽静的山谷小径。两侧绿树掩映，溪水潺潺，是情侣约会和学子休憩的好去处。谷中有一座小桥，桥下流水叮咚，充满诗情画意。

### 白城沙滩
穿过厦大校门，步行几分钟即可到达白城沙滩。这里是全国唯一一个紧邻海滩的大学校园。夕阳西下时，金色的阳光洒在海面上，与校园的红瓦绿树构成一幅绝美的画卷。

## 校园文化

厦大的校园文化与自然景观一样丰富多彩。每年的"厦大之星"评选、校园歌手大赛、沙滩音乐节等活动，吸引着全国各地的游客前来参与。

## 美食推荐

来厦大不可错过的美食包括：勤业餐厅的沙茶面、南光餐厅的海蛎煎、芙蓉餐厅的姜母鸭。这些地道的闽南美食为校园生活增添了独特的风味。`,
    category: "meili-xiaoyuan",
    author: "旅行作家 赵琳",
    publishDate: "2025-06-22",
    readTime: "8分钟",
    imageSeq: "article-xmu-1",
    tags: ["厦门大学", "最美校园", "校园风光", "海滨校园"],
  },
  {
    id: 8,
    title: "毕业季：那些关于校花的最后记忆",
    slug: "graduation-season-last-memories",
    excerpt: "六月的校园，弥漫着栀子花的香气和离别的伤感。在这个特殊的季节里，我们一起回顾那些年一起追过的校花，重温那些即将告别的青春故事。",
    content: `六月的校园，弥漫着栀子花的香气和离别的伤感。在这个特殊的季节里，我们一起回顾那些年一起追过的校花，重温那些即将告别的青春故事。

## 毕业前的最后一面

毕业前的最后一个月，校园里充满了告别。图书馆前穿着学士服合影的人群，操场上最后一次班级聚会，食堂里最后一次聚餐。

而对于很多男生来说，毕业前还有个未了的心愿——再见一次那个在校园里远远望过无数次的她。

"毕业典礼那天，我终于鼓起勇气找她合影了。"一位毕业生在社交平台上分享，"四年来第一次也是最后一次和她说话，虽然只是简单的'可以合个影吗'和'毕业快乐'，但已经足够。"

## 校花毕业去向

那些曾经备受瞩目的校花们，毕业后的去向也各不相同：

有的选择继续深造，考入国内外名校攻读研究生；有的进入知名企业，开启职场生涯；有的投身创业，在商业领域大展拳脚；还有的回归普通生活，在平凡的岗位上发光发热。

"校花只是一个阶段的标签，"一位毕业多年的校友说，"真正重要的是毕业后你成为了什么样的人。"

## 青春不散场

虽然毕业意味着告别校园，但青春的记忆永远不会消失。那些关于校花的故事，那些一起追过的日子，都将成为人生中最珍贵的财富。

"愿所有即将毕业的学子，前程似锦，归来仍是少年。"`,
    category: "qingchun-jiyi",
    author: "校园编辑 周洁",
    publishDate: "2025-06-15",
    readTime: "6分钟",
    imageSeq: "article-graduation-1",
    tags: ["毕业季", "青春记忆", "校花", "校园生活"],
  },
  {
    id: 9,
    title: "校花评选背后的社会心理学：为何我们如此关注校花？",
    slug: "psychology-behind-campus-belle",
    excerpt: "校花评选作为一种独特的校园文化现象，背后蕴含着丰富的社会心理学原理。从群体认同到审美偏好，从社交需求到青春崇拜，本文将深入分析校花文化盛行的深层原因。",
    content: `校花评选作为一种独特的校园文化现象，背后蕴含着丰富的社会心理学原理。

## 群体认同理论

社会心理学家泰弗尔提出的社会认同理论认为，个体通过群体分类来获得自我认同。校花评选本质上是一种群体认同行为——通过共同关注和讨论校花，学生们建立了一种共享的校园文化身份。

"当我们讨论'我们学校的校花'时，'我们学校'这个前缀本身就包含了一种集体归属感。"北京大学心理学教授李明分析道。

## 审美与进化心理学

从进化心理学角度看，人类对美的偏好具有一定的生物学基础。对称的面孔、健康的肤色、匀称的身材等特征在进化过程中被视为良好基因的标志。

然而，当代校花评选已远超生物学层面的审美判断。评选标准中越来越多地融入了社会文化因素，如学识、才艺、公益精神等。

## 社交媒体的放大效应

新媒体时代，校花评选获得了前所未有的传播力。一条关于校花的短视频可以在几小时内获得百万播放量。这种"网红效应"进一步强化了校花文化的影响力。

## 青春崇拜

校花文化也反映了社会对青春的崇拜。"校花"本质上是对青春美的礼赞，是人们对大学时光——人生中最美好阶段的怀念与向往。

## 理性看待校花文化

校花文化既有积极的一面（展示女性多元价值、丰富校园文化），也有需要反思的一面（过度关注外表、可能带来不必要的压力）。建立健康、理性的校园审美文化，需要全社会的共同努力。`,
    category: "xiaohua-pingxuan",
    author: "心理学研究员 吴婷",
    publishDate: "2025-05-20",
    readTime: "11分钟",
    imageSeq: "article-psych-1",
    tags: ["社会心理学", "校花文化", "审美", "校园现象"],
  },
  {
    id: 10,
    title: "复旦才女周晓棠：从校花到医学博士的精彩人生",
    slug: "fudan-zhou-xiaotang-medical-doctor",
    excerpt: '复旦大学2020届校花周晓棠在毕业五年后已成为一名出色的心内科医生。她在繁忙的临床工作之余，还坚持做医学科普，在社交媒体上拥有百万粉丝。',
    content: `复旦大学2020届校花周晓棠在毕业五年后已成为一名出色的心内科医生。

## 校园时光

周晓棠在复旦大学医学院就读期间，就以优异的成绩和出众的气质成为校园焦点。她连续四年获得国家奖学金，同时担任校学生会文艺部部长。

2020年，在复旦大学校花评选中，周晓棠以独特的"白衣天使"形象参赛。她身穿白大褂的照片在校园内引起轰动，"最美医学生"的称号不胫而走。

## 医学之路

毕业后，周晓棠进入复旦大学附属中山医院工作。她从住院医师做起，经历了无数个夜班、无数台手术，用五年时间成长为一名独当一面的心内科主治医师。

"医生这个职业很辛苦，但每当看到病人康复出院，所有的疲惫都烟消云散了。"周晓棠说。

## 科普达人

在繁忙的临床工作之余，周晓棠坚持在社交媒体上进行医学科普。她在抖音上开设了"晓棠医生"账号，以通俗易懂的方式讲解心血管健康知识，目前粉丝已突破200万。

"我希望用自己的专业知识帮助更多人。预防永远比治疗更重要。"

## 对校花标签的看法

回顾当年的校花经历，周晓棠显得很淡然："校花只是一个阶段性的标签，我相信每个人都可以在自己的领域成为'最美'的那个。"`,
    category: "xiaohua-gushi",
    author: "健康记者 马丽",
    publishDate: "2025-04-12",
    readTime: "8分钟",
    imageSeq: "article-fudan-1",
    tags: ["复旦大学", "周晓棠", "医学博士", "校花故事"],
  },
  {
    id: 11,
    title: "南京大学：百年学府的秋日私语",
    slug: "nju-autumn-campus-beauty",
    excerpt: "南京大学的秋天是一年中最美的季节。金黄的法桐叶铺满北园大道，鼓楼校区的百年建筑在秋日阳光下散发着历史的厚重感。让我们一起漫步南大，感受百年学府的独特魅力。",
    content: `南京大学的秋天是一年中最美的季节。金黄的法桐叶铺满北园大道，鼓楼校区的百年建筑在秋日阳光下散发着历史的厚重感。

## 百年学府

南京大学的前身是创建于1902年的三江师范学堂，至今已有120余年的历史。作为中国最著名的高等学府之一，南大培养了无数杰出人才。

## 鼓楼校区

鼓楼校区是南大历史最悠久的校区，保留了大量民国时期的建筑。北大楼、大礼堂、小礼堂等建筑见证了南大的百年风雨。

秋天是鼓楼校区最美的季节。北园大道两侧的法桐树叶由绿转黄，层层叠叠的落叶铺就了一条金色大道。阳光透过树叶的缝隙洒下斑驳的光影，漫步其中，仿佛穿越了时光。

## 仙林校区

仙林校区是南大的新校区，以现代化建筑和优美的生态环境著称。校区内的杜厦图书馆是亚洲最大的大学图书馆之一，设计独特，被誉为"高校最美图书馆"。

## 校园风物

南大校园内还有多处独特的景观：香雪海的梅花、星湖的荷花、紫金山的远眺。每个季节都有不同的风景，每次造访都有新的发现。

## 南大之星

南大也有自己的校花评选传统——"南大之星"。与一般的校花评选不同，"南大之星"更注重学术能力和社会责任感，评选出的"校花"往往是在学术或社会服务领域有突出贡献的优秀学子。`,
    category: "meili-xiaoyuan",
    author: "文化记者 张磊",
    publishDate: "2025-10-28",
    readTime: "7分钟",
    imageSeq: "article-nju-1",
    tags: ["南京大学", "校园风光", "最美校园", "秋日"],
  },
  {
    id: 12,
    title: "大一新生的校花初印象：第一次遇见她的那个秋天",
    slug: "freshman-first-impression-campus-belle",
    excerpt: '每个大一新生都有一段关于「第一次遇见校花」的独特记忆。那个秋天，拖着行李箱走进陌生的校园，在人海中偶然瞥见的那一抹身影，成为了大学四年最难忘的风景。',
    content: `每个大一新生都有一段关于"第一次遇见校花"的独特记忆。

## 开学第一天

九月的校园，到处是拖着行李箱的新生和家长。军训的迷彩服还没有发下来，大家都穿着自己的衣服，在陌生的校园里摸索着。

"那天我在去报到的路上，经过图书馆门口，看到一个学姐在帮新生指路。"一位大三学生回忆道，"她穿着白色的连衣裙，长发披肩，笑起来特别温暖。那一刻我就觉得，这个学校来对了。"

## 军训时光

军训是新生们第一次真正接触校园文化的时刻。在烈日下站军姿、踢正步的间隙，大家最期待的就是休息时看看场边的学姐学长们。

"我们连队旁边有一个舞蹈社在排练，领舞的学姐特别好看。"一位大二学生笑道，"那两周我们连队的男生站军姿特别有精神，因为都想着好好表现。"

## 迎新晚会

迎新晚会是校花"出圈"的重要场合。当主持人介绍学生代表上台发言时，台下往往会爆发热烈的掌声和欢呼声。那些在迎新晚会上亮相的学姐，往往成为新生班级群里的热议话题。

## 最初的仰望

对于很多新生来说，对校花的最初感受是一种"仰望"。她看起来那么完美——成绩好、长得美、多才多艺，仿佛是另一个世界的人。但随着时间推移，当你也渐渐融入校园生活，你会发现那些曾经仰望的对象，也不过是努力生活的普通人。

"现在我大三了，有时候在路上看到新生用当年我看校花的那种眼神看我，我会心一笑。"一位学姐说，"这就是青春啊，永远有新的故事在上演。"`,
    category: "qingchun-jiyi",
    author: "学生记者 林小雨",
    publishDate: "2025-09-01",
    readTime: "7分钟",
    imageSeq: "article-freshman-1",
    tags: ["大一新生", "青春记忆", "校园初印象", "大学生活"],
  },
];